import { propertyTenantedService } from '@/services/api/propertyTenanted.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { properttyTenantedModel } from '@/models/api/propertyTenanted.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const PROPERTY_TENANTED_MODULE = "api/propertyTenanted";

// ACTIONS
export const GET_ALL_PROPERTY_TENANTED = 'getAllPropertyTenanted';
export const CREATE_PROPERTY_TENANTED = 'createPropertyTenanted';
export const GET_PROPERTY_TENANTED = 'getPropertyTenanted';
export const UPDATE_PROPERTY_TENANTED = 'updatePropertyTenanted';
export const UPDATE_PROPERTY_TENANTED_STATUS = 'updatePropertyTenantedStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_PROPERTY_TENANTED_SUCCESS = "allPropertyTenantedSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_PROPERTY_TENANTED_SUCCESS = "getPropertyTenantedSuccess";

export const actions = {
    [GET_ALL_PROPERTY_TENANTED]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        propertyTenantedService
            .getAll(filter)
            .then((result) => {
                commit(ALL_PROPERTY_TENANTED_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_PROPERTY_TENANTED]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return propertyTenantedService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_TENANTED, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_PROPERTY_TENANTED]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return propertyTenantedService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_PROPERTY_TENANTED_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_PROPERTY_TENANTED]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return propertyTenantedService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_TENANTED, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_PROPERTY_TENANTED_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return propertyTenantedService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_TENANTED, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_PROPERTY_TENANTED_SUCCESS](state, {data}) {
        let propertyTenanted = data.data || [];
        state.list.data = propertyTenanted;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = propertyTenanted.map(item => properttyTenantedModel(item));
        }
    },
    [GET_PROPERTY_TENANTED_SUCCESS](state, data) {
        state.details = properttyTenantedModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
